import { useCallback, useEffect, useState } from "react";
import auth from "../../services/auth";
import v2DashboardApi, {
  getAwsUrlToViewMedia,
} from "../services/v2DashboardApi";
import { ensureAccountId } from "../session";

export const MESSAGES_MODAL_SHOWN_KEY = "messagesModalShown";

const markShown = () => {
  try {
    localStorage.setItem(MESSAGES_MODAL_SHOWN_KEY, "true");
  } catch {
    // ignore storage errors
  }
};

const wasAlreadyShown = () => {
  try {
    return Boolean(localStorage.getItem(MESSAGES_MODAL_SHOWN_KEY));
  } catch {
    return false;
  }
};

export function useUserMessages() {
  const [messages, setMessages] = useState([]);
  const [open, setOpen] = useState(false);
  const [accountId, setAccountId] = useState(null);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      if (wasAlreadyShown()) return;

      try {
        const nextAccountId = await ensureAccountId();
        const nextUserId = auth.getUserId();
        if (cancelled) return;
        if (!nextAccountId || !nextUserId || nextUserId === -1) return;

        setAccountId(nextAccountId);
        setUserId(nextUserId);

        const userMessages = await v2DashboardApi().getAllUserMessages(
          nextAccountId,
          nextUserId
        );
        if (cancelled) return;

        for (const msg of userMessages) {
          msg.content = await getAwsUrlToViewMedia(msg.content);
        }
        if (cancelled) return;

        markShown();
        if (userMessages.length > 0) {
          setMessages(userMessages);
          setOpen(true);
        }
      } catch {
        if (!cancelled) setOpen(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleClose = useCallback(() => {
    markShown();
    setOpen(false);
  }, []);

  return { messages, open, accountId, userId, handleClose };
}
